import { Popover } from "@mui/material";
import { useState } from "react";
import Email from "../../Buttons/SharesButtons/Email";
import Facebook from "../../Buttons/SharesButtons/Facebook";
import Whatsapp from "../../Buttons/SharesButtons/Whatsapp";
import classes from "./SharePopover.module.css";

const SharePopover = (props) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  return (
    <div>
      <div
        aria-owns={open ? "mouse-over-popover" : undefined}
        aria-haspopup="true"
        onClick={handlePopoverOpen}
      >
        {props.children}
      </div>
      <Popover
        classes={{ paper: classes.paper }}
        open={open}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <Email
          userName={props.userName}
          siteName={props.siteName}
          getSelectedValues={props.getSelectedValues}
          parkingHistoryId={props.parkingHistoryId}
        />
        <Facebook getSelectedValues={props.getSelectedValues}  parkingHistoryId={props.parkingHistoryId}/>
        <Whatsapp getSelectedValues={props.getSelectedValues} parkingHistoryId={props.parkingHistoryId}/>
      </Popover>
    </div>
  );
};

export default SharePopover;
